import { Middleware, UnknownAction } from '@reduxjs/toolkit';
import { analyticsManager } from '@/analytics';
import { AuthSlice, IAuthError } from '../reducers/AuthReducer';
import { RootState } from '../index';

export const analyticsMiddleware: Middleware<object, RootState> = (store) => (next) => (action: unknown) => {
    if (!isUnknownAction(action)) {
        return next(action);
    }

    const result = next(action);

    // Отслеживаем успешный логин
    if (action.type === AuthSlice.actions.successLogin.type) {
        const state = store.getState() as RootState;
        const user = state.auth.user;

        analyticsManager.setUserId(user.login);

        analyticsManager.trackEvent({
            category: 'Authentication',
            action: 'login',
            name: 'Вход в систему',
            customDimensions: [
                {
                    id: 1,
                    value: user.id.toString(),
                },
                {
                    id: 2,
                    value: user.email,
                },
                {
                    id: 3,
                    value: user.username,
                },
                {
                    id: 4,
                    value: user.fullName,
                },
            ],
        });
        analyticsManager.deleteCustomDimensions([1, 2, 3, 4]);
    }

    // Отслеживаем логаут
    if (action.type === AuthSlice.actions.successLogout.type) {
        analyticsManager.trackEvent({
            category: 'Authentication',
            action: 'logout',
            name: 'Выход из системы',
        });

        analyticsManager.resetUserId();
    }

    // Отслеживаем ошибки авторизации
    if (action.type === AuthSlice.actions.setError.type) {
        const error = action.payload as IAuthError;
        if (error.message) {
            analyticsManager.trackEvent({
                category: 'Authentication',
                action: 'error',
                name: 'Ошибка входа',
                customDimensions: [
                    {
                        id: 11,
                        value: error.message,
                    },
                    {
                        id: 12,
                        value: error.login ?? '',
                    },
                    {
                        id: 13,
                        value: error.loginType ?? '',
                    },
                ],
            });
            analyticsManager.deleteCustomDimensions([11, 12, 13]);
        }
    }

    return result;
};

function isUnknownAction(action: unknown): action is UnknownAction {
    return typeof action === 'object' && action !== null && 'type' in action;
}
